export const orientations = {
    horizontal: 'horizontal',
    vertical: 'vertical',
};
